import { useFireClientAction } from '@euler/app/components/ai/useFireClientAction';
import { useCallback } from 'react';
import { useBiDashboardHost } from '../../bi-dashboard-changes/BiDashboardHostContext';

/**
 * Opens a dashboard from a card in the chat, the way the server's
 * **Open dashboard** link does. On that dashboard's own page it only
 * brings the dashboard into view.
 */
export function useOpenBiDashboard() {
  const fire = useFireClientAction();
  const host = useBiDashboardHost();
  return useCallback(
    (dashboardId: string, name: string) => {
      host?.reveal?.();
      if (host?.dashboardId === dashboardId) return;
      void fire({
        action: 'navigate',
        page: 'bi_dashboard',
        params: { dashboardId },
        label: name,
      });
    },
    [fire, host],
  );
}
